import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import { Box } from "@mui/material";
import TabPanel from "@mui/lab/TabPanel";
import Appointments from "./components/appointments/Appointments";
import { useEffect, useState } from "react";
import Encounters from "./components/encounters/Encounters";
import Patients from "./Patients";
import { setItem } from "../../utilis/methods/storage/storage";
import { useLocation } from "react-router-dom";

const Reception = () => {
  const [value, setValue] = useState("1");
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const handleChange = (_: React.SyntheticEvent, newValue: number) => {
    setValue(newValue.toString());
    setItem("selectedTab", newValue);
  };

  useEffect(() => {
    // const storedTab = getItem("selectedTab");
    // if (storedTab !== null) {
    //   setValue(String(storedTab));
    //   localStorage.removeItem("selectedTab");
    // }
    const tab = query.get("tab");
    if(tab){
      setValue(tab);
    }
  }, [location.search]);

  return (
    <TabContext value={value} aria-label="icon tabs example">
      <Box sx={{ border: 1, borderColor: "divider" }}>
        <TabList
          variant="fullWidth"
          onChange={handleChange}
          aria-label="lab API tabs example"
        >
          <Tab label="Appointments" value="1" />
          <Tab label="Encounters" value="2" />
          <Tab label="Registrations" value="3" />
        </TabList>
      </Box>
      <TabPanel value="1">
        <Appointments />
      </TabPanel>
      <TabPanel value="2">
        <Encounters />
      </TabPanel>
      <TabPanel value="3">
        <Patients />
      </TabPanel>
    </TabContext>
  );
};
export default Reception;

